import { createAsyncThunk } from '@reduxjs/toolkit';
// eslint-disable-next-line no-restricted-imports
import { ApiFactory, ApiResponse } from 'shared/api';
import BaseError from 'utils/base-error';
import { z } from 'zod';

/**
 * Инстанс апишки
 */
const apiInstance = ApiFactory.getInstance();

/**
 * Схема для парсинга респонса
 */
export const GetSweetShopArticlesByCategoryUidAndTagUidApiResponseSchema = z.object({
    data: z.array(
        z.object({
            documentId: z.string(),
            slug: z.string(),
            name: z.string(),
            description: z.any().optional().nullable(),
            category: z.object({
                documentId: z.string(),
                slug: z.string(),
            }).optional().nullable(),
            tags: z.array(
                z.object({
                    documentId: z.string(),
                    slug: z.string(),
                }),
            ).optional().nullable(),
            images: z.array(
                z.object({
                    url: z.string(),
                }),
            ).optional().nullable(),
            price: z.number().optional().nullable(),
            weight: z.number().optional().nullable(),
            currency: z.object({
                name: z.string(),
                abbreviation: z.string(),
            }).optional().nullable(),
        }),
    ),
});

type GetSweetShopArticlesByCategoryUidAndTagUidActionResponse
    = ApiResponse<z.infer<typeof GetSweetShopArticlesByCategoryUidAndTagUidApiResponseSchema>>
    | BaseError;

type GetSweetShopArticlesByCategoryUidAndTagUidActionRequest = {
    categoryUid: string
    tagUid?: string
}

export const getSweetShopArticlesByCategoryUidAndTagUid = createAsyncThunk<
    GetSweetShopArticlesByCategoryUidAndTagUidActionResponse,
    GetSweetShopArticlesByCategoryUidAndTagUidActionRequest
>(
    'SweetShopArticlesPageActionsGetSweetShopArticlesByCategoryUidAndTagUid',
    async ({
        categoryUid,
        tagUid,
    }) => apiInstance.get(
        '/sweet-shop-articles',
        {
            'filters[category][slug][$eq]': categoryUid,
            'filters[tags][slug][$eq]': tagUid,
            'fields[0]': '*',
            'populate[category][fields]': '*',
            'populate[tags][fields]': '*',
            'populate[images][fields][2]': 'url',
            'populate[currency][fields][0]': '*',
        },
        GetSweetShopArticlesByCategoryUidAndTagUidApiResponseSchema,
    ),
);
